<script>
import OrderSetting from "@/views/orderManagement/set.vue";

export default OrderSetting;
</script>
